import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { Box, Typography, alpha } from "@mui/material";
import "./dashboard.css";
import IdentityVerificationAddress from "./IdentityVerificationAddress";
import IdentityVerificationDOB from "./IdentityVerificationDOB";
import IdentityVerificationEmployee from "./IdentityVerificationEmployee";
import IdentityVerificationDocument from "./IdentityVerificationDocument";
import {
  getDashBoardInfo,
  showCustomAlert,
  showToast,
  WEBSERVICE,
} from "../../CoreDataService";
import axios from "axios";
import IDTier2 from "./IDTier2";
import Loading from "../Loading";
import CompanyInformation from "./CompanyInformation";
import CompanyDocumentUpload from "./CompanyDocumentUpload";
import IDTierDeclined from "./Decliened";
import BeneficialOwners from "./BeneficialOwners";
import Tier3Document from "./Tier3Document";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import ModalContent from "../../Common/Modal";
import InfoPopUp from "../../Common/InfoPopUp";
import { useSelector } from "react-redux";
import { ContainedButton, OutlinedButton } from "../../Common/Buttons";
import InfoIcon from "@mui/icons-material/Info";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
export const allowOnlyAlphabetsCityState = (e) => {
  const key = e.key;
  // allow backspace, tab, arrows, delete
  if (
    key === "Backspace" ||
    key === "Tab" ||
    key === "ArrowLeft" ||
    key === "ArrowRight" ||
    key === "Delete"
  ) {
    return;
  }
  // allow letters and space
  const regex = /^[a-zA-Z\s]$/;
  if (!regex.test(key)) {
    e.preventDefault(); // block invalid char
  }
};

export const PreventPasteCityState = (event) => {
  const paste = (event.clipboardData || window.clipboardData).getData("text");
  const regex = /^[a-zA-Z\s]$/;
  if (!regex.test(paste)) {
    event.preventDefault(); // Block disallowed paste
  }
};

const allowedRegex = /^[a-zA-Z0-9 ]*$/;
export const OnlyAllowedInput = (event) => {
  const { key } = event;

  // Allow control keys
  if (
    key === "Backspace" ||
    key === "Delete" ||
    key === "ArrowLeft" ||
    key === "ArrowRight" ||
    key === "Tab"
  ) {
    return;
  }

  // Check if key is a single character and test it
  if (!allowedRegex.test(key)) {
    event.preventDefault(); // Block disallowed characters
  }
};

export const PreventPasteInput = (event) => {
  const paste = (event.clipboardData || window.clipboardData).getData("text");
  if (!allowedRegex.test(paste)) {
    event.preventDefault(); // Block disallowed paste
  }
};
const allowedRegexHouse = /^[A-Za-z0-9 /,.#-]*$/;
export const OnlyAllowedInputHouse = (event) => {
  const { key } = event;

  // Allow control keys
  if (
    key === "Backspace" ||
    key === "Delete" ||
    key === "ArrowLeft" ||
    key === "ArrowRight" ||
    key === "Tab"
  ) {
    return;
  }

  // Check if key is a single character and test it
  if (!allowedRegexHouse.test(key)) {
    event.preventDefault(); // Block disallowed characters
  }
};
export const PreventPasteHouse = (event) => {
  const paste = (event.clipboardData || window.clipboardData).getData("text");
  if (!allowedRegexHouse.test(paste)) {
    event.preventDefault(); // Block disallowed paste
  }
};
const allowedRegexStreet = /^[\p{L}\p{N} ,\-\/.#&'()]*$/u;
export const OnlyAllowedInputStreet = (event) => {
  const { key } = event;

  // Allow control keys
  if (
    key === "Backspace" ||
    key === "Delete" ||
    key === "ArrowLeft" ||
    key === "ArrowRight" ||
    key === "Tab"
  ) {
    return;
  }

  // Check if key is a single character and test it
  if (!allowedRegexStreet.test(key)) {
    event.preventDefault(); // Block disallowed characters
  }
};

export const PreventPasteStreet = (event) => {
  const paste = (event.clipboardData || window.clipboardData).getData("text");
  if (!allowedRegexStreet.test(paste)) {
    event.preventDefault(); // Block disallowed paste
  }
};
export const OnlyAllowedInputZipCode = (event) => {
  const regex = /[^a-zA-Z0-9 @$!.]/g;
  const { key } = event;
  const value = event.target.value;

  // Allow control keys
  if (
    key === "Backspace" ||
    key === "Delete" ||
    key === "ArrowLeft" ||
    key === "ArrowRight" ||
    key === "Tab"
  ) {
    return;
  }

  // Check if key is a single character and test it
  if (regex.test(key) || value?.length >= 15) {
    event.preventDefault(); // Block disallowed characters
  }
};
export const PreventPasteZipCode = (event) => {
  const paste = (event.clipboardData || window.clipboardData).getData("text");
  const regex = /[^a-zA-Z0-9 @$!.]/g;
  if (!regex.test(paste)) {
    event.preventDefault(); // Block disallowed paste
  }
};
export const OnlyAllowedZipCode = (event) => {
  const regex = /^[a-zA-Z0-9 ]*$/;
  const { key } = event;
  const value = event.target.value;

  // Allow control keys
  if (
    key === "Backspace" ||
    key === "Delete" ||
    key === "ArrowLeft" ||
    key === "ArrowRight" ||
    key === "Tab"
  ) {
    return;
  }

  // Check if key is a single character and test it
  if (!regex.test(key) || value?.length >= 15) {
    event.preventDefault(); // Block disallowed characters
  }
};
export const OnlyAllowedInputBankPartner = (event) => {
  const regex = /[^a-zA-Z0-9 @$!.]/g;
  const { key } = event;
  const value = event.target.value;

  // Allow control keys
  if (
    key === "Backspace" ||
    key === "Delete" ||
    key === "ArrowLeft" ||
    key === "ArrowRight" ||
    key === "Tab"
  ) {
    return;
  }

  // Check if key is a single character and test it
  if (regex.test(key)) {
    event.preventDefault(); // Block disallowed characters
  }
};

export const allowOnlyAlphaNumSlash = (e) => {
  const key = e.key;
  // allow backspace, tab, arrows, delete
  if (
    key === "Backspace" ||
    key === "Tab" ||
    key === "ArrowLeft" ||
    key === "ArrowRight" ||
    key === "Delete"
  ) {
    return;
  }
  // allow letters and space
  const regex = /^[a-zA-Z0-9 /]$/;
  if (!regex.test(key)) {
    e.preventDefault(); // block invalid char
  }
};
export const allowWebsiteUrl = (e) => {
  const key = e.key;
  // allow backspace, tab, arrows, delete
  if (
    key === "Backspace" ||
    key === "Tab" ||
    key === "ArrowLeft" ||
    key === "ArrowRight" ||
    key === "Delete"
  ) {
    return;
  }
  // allow letters and space
  const regex = /^[a-zA-Z0-9\-._~:/?#[\]@!$&'()*+,;=]*$/;
  if (!regex.test(key)) {
    e.preventDefault(); // block invalid char
  }
};

export const allowedFileTypes = [
  "image/png",
  "image/jpeg",
  "image/jpg",
  "image/jfif",
  "image/heic",
  "image/bmp",
  "application/pdf",
  "application/msword", // .doc
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
];

export const maxFileSizeMB = 6;

export const validateFile = {
  fileType: (value) => {
    if (!value || !value.length) return "File is required";
    const type = value[0]?.type;
    return allowedFileTypes.includes(type) ? true : "Invalid file type.";
  },
  fileSize: (value) => {
    if (!value || !value.length) return "File is required";
    const size = value[0]?.size;
    return size <= maxFileSizeMB * 1024 * 1024
      ? true
      : `File size exceeds ${maxFileSizeMB}MB.`;
  },
};

export const allowedFilePNGJPEG = ["image/png", "image/jpeg"];
export const allowedExtensions = [".png", ".jpeg", ".jpg"];

export const validateFilePNGJPEG = {
  fileType: (value) => {
    if (!value || !value.length) return "File is required";

    const file = value[0];
    const type = file.type;
    const name = file.name.toLowerCase();
    const extension = name.substring(name.lastIndexOf("."));

    if (!allowedFilePNGJPEG.includes(type)) {
      return "Invalid file type.";
    }

    if (!allowedExtensions.includes(extension)) {
      return "Only .PNG or .JPEG files are allowed.";
    }

    return true;
  },

  fileSize: (value) => {
    if (!value || !value.length) return "File is required";

    const size = value[0]?.size;
    return size <= maxFileSizeMB * 1024 * 1024
      ? true
      : `File size exceeds ${maxFileSizeMB}MB.`;
  },
};

const Dashboard = () => {
  const { btncolor } = useSelector((state) => state);
  const theme = localStorage.getItem("theme");
  const uuid = localStorage.getItem("uuid");
  const token = localStorage.getItem("access_token");
  const userId = localStorage.getItem("userId");
  const [show, setShow] = useState(false);
  const [userTypeModal, setUserTypeModal] = useState(false);
  const [userType, setUserType] = useState(null);
  const [steps, setSteps] = useState(1);
  const [userDetails, setUserDetails] = useState([]);
  const [isLoading, setIsloading] = useState(false);

  const handleClose = () => setShow(false);
  const handleCloseUserTypeModal = () => setUserTypeModal(false);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(false), 3800); // delay + duration
    return () => clearTimeout(timer);
  }, []);
  const handleSteps = () => {
    setSteps(steps + 1);
  };
  const handleBack = () => {
    setSteps(steps - 1);
    getUserDetails();
  };

  useEffect(() => {
    getUserDetails();
  }, [steps]);
  useEffect(() => {
    getDashBoardInfo();
  }, []);

  const getUserDetails = async () => {
    setIsloading(true);
    const data = {
      userId: userId,
      uuid: uuid,
    };
    try {
      const response = await axios.post(
        `${WEBSERVICE}user/GetUserDetails`,
        data,
        {
          headers: {
            Authorization: `BEARER ${token}`, // Include the token in the Authorization header
          },
        }
      );
      setIsloading(false);

      console.log("response details", response);
      setUserDetails(response?.data?.userResult);
      if (!userType) {
        setUserType(
          response?.data?.userResult?.userType === 0
            ? null
            : response?.data?.userResult?.userType
        );
      }
    } catch (err) {
      showToast("error", err?.response?.data?.error?.error_msg);
      setIsloading(false);
    }
  };

  return (
    <Box
      style={{
        height: "100%",
        padding: "1px",
        overflowX: "hidden",
      }}
    >
      {(userDetails?.userDocsStatus === "1" &&
        userDetails?.userTierType === 2) ||
      userDetails?.userTierType === 3 ? (
        <Tier3Document
          userDetails={userDetails}
          steps={steps}
          setIsloading={setIsloading}
        />
      ) : userDetails?.userDocsStatus === "0" &&
        userDetails?.isKycFinished === 1 ? (
        <IDTier2 />
      ) : userDetails?.userDocsStatus === "0" &&
        userDetails?.isKycFinished === 0 &&
        userType === 2 ? (
        <BeneficialOwners
          handleSteps={handleSteps}
          handleBack={handleBack}
          userDetails={userDetails}
          setIsloading={setIsloading}
          steps={5}
          payload={""}
        />
      ) : (
        <>
          {userDetails?.userDocsStatus === "2" && steps === 1 && (
            <IDTierDeclined />
          )}

          {!userDetails?.userDocsStatus && visible && (
            <div className="info-banner">
              PLEASE SUBMIT DOCUMENTS, ENSURE THAT ALL DOCUMENTS ARE IN JPG,
              JPEG, PNG, DOC OR PDF FORMAT. GIF and other formats are not
              permitted.
            </div>
          )}

          {steps === 1 && (
            <Box
              sx={{
                px: { xs: 2, md: 4 },
                py: { xs: 4, md: 6 },
                backgroundColor: "var(--body-color)",
                color: "var(--text-color)",
              }}
            >
              {/* Header */}
              <Box sx={{ textAlign: "center", mb: 6 }}>
                <Typography
                  sx={{
                    fontSize: { xs: "1.8rem", md: "2.4rem" },
                    fontWeight: 800,
                    color: "var(--text-color)",
                    mb: 1.5,
                  }}
                >
                  KYC Verification
                </Typography>
                <Typography
                  sx={{
                    fontSize: { xs: "0.95rem", md: "1.1rem" },
                    color: "var(--text-color)",
                    opacity: 0.6,
                    maxWidth: 600,
                    mx: "auto",
                  }}
                >
                  Please select your account type to begin verification and
                  unlock full platform access.
                </Typography>
              </Box>

              {/* Selection Cards */}
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                  gap: 4,
                  maxWidth: 900,
                  mx: "auto",
                }}
              >
                {/* Individual Card */}
                <Box
                  sx={{
                    backgroundColor: "var(--body-color-less)",
                    borderRadius: "24px",
                    border: "1px solid rgba(125,125,125,0.15)",
                    p: { xs: 3, md: 4 },
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-8px)",
                      boxShadow: "0 20px 40px rgba(0,0,0,0.12)",
                      borderColor: alpha(btncolor || "#1976d2", 0.3),
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: 80,
                      height: 80,
                      borderRadius: "20px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: alpha(btncolor || "#1976d2", 0.1),
                      color: btncolor,
                      mb: 3,
                    }}
                  >
                    <PersonOutlineIcon sx={{ fontSize: 44 }} />
                  </Box>
                  <Typography
                    sx={{ fontSize: "1.5rem", fontWeight: 700, mb: 1 }}
                  >
                    Individual
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      width: "fit-content",
                      mb: 0,
                      px: 2,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "0.9rem",
                        color: "var(--text-color)",
                        opacity: 0.55,
                        mb: 3,
                        textAlign: "left",
                      }}
                    >
                      For personal accounts and individual traders
                    </Typography>

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1.5,
                        mt: 1,
                        mb: 4,
                      }}
                    >
                      {[
                        "Personal ID verification",
                        "Address proof upload",
                        "Employment details",
                        "Photo verification",
                      ].map((feature, i) => (
                        <Box
                          key={i}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1.5,
                          }}
                        >
                          <CheckOutlinedIcon
                            sx={{ fontSize: 18, color: "#16a34a" }}
                          />
                          <Typography
                            sx={{
                              fontSize: "0.85rem",
                              color: "var(--text-color)",
                              opacity: 0.85,
                            }}
                          >
                            {feature}
                          </Typography>
                        </Box>
                      ))}
                    </Box>

                    <ContainedButton
                      onClick={() => {
                        setUserType(1);
                        handleSteps();
                      }}
                      sx={{
                        height: 48,
                        borderRadius: "12px",
                        px: 4,
                        fontWeight: 700,
                        textTransform: "none",
                        fontSize: "0.95rem",
                      }}
                    >
                      Select Individual
                    </ContainedButton>
                  </Box>
                </Box>

                {/* Enterprise Card */}
                <Box
                  sx={{
                    backgroundColor: "var(--body-color-less)",
                    borderRadius: "24px",
                    border: "1px solid rgba(125,125,125,0.15)",
                    p: { xs: 3, md: 4 },
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-8px)",
                      boxShadow: "0 20px 40px rgba(0,0,0,0.12)",
                      borderColor: alpha(btncolor || "#1976d2", 0.3),
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: 80,
                      height: 80,
                      borderRadius: "20px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: alpha(btncolor || "#1976d2", 0.1),
                      color: btncolor,
                      mb: 3,
                    }}
                  >
                    <BusinessCenterOutlinedIcon sx={{ fontSize: 40 }} />
                  </Box>
                  <Typography
                    sx={{ fontSize: "1.5rem", fontWeight: 700, mb: 1 }}
                  >
                    Enterprise
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      width: "fit-content",
                      mb: 0,
                      px: 2,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "0.9rem",
                        color: "var(--text-color)",
                        opacity: 0.55,
                        mb: 3,
                        textAlign: "left",
                      }}
                    >
                      For businesses and corporate accounts
                    </Typography>

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1.5,
                        mt: 1,
                        mb: 4,
                      }}
                    >
                      {[
                        "Company information",
                        "Business documents",
                        "Authorization letter",
                        "Beneficial owners",
                      ].map((feature, i) => (
                        <Box
                          key={i}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1.5,
                          }}
                        >
                          <CheckOutlinedIcon
                            sx={{ fontSize: 18, color: "#16a34a" }}
                          />
                          <Typography
                            sx={{
                              fontSize: "0.85rem",
                              color: "var(--text-color)",
                              opacity: 0.85,
                            }}
                          >
                            {feature}
                          </Typography>
                        </Box>
                      ))}
                    </Box>

                    <ContainedButton
                      onClick={() => {
                        setUserType(2);
                        handleSteps();
                      }}
                      sx={{
                        height: 48,
                        borderRadius: "12px",
                        px: 4,
                        fontWeight: 700,
                        textTransform: "none",
                        fontSize: "0.95rem",
                      }}
                    >
                      Select Enterprise
                    </ContainedButton>
                  </Box>
                </Box>
              </Box>

              <Box
                sx={{
                  mt: 2,
                  mx: "auto",
                  maxWidth: 900, // Matches the selection cards maxWidth
                  p: 3,
                  borderRadius: "16px",
                  backgroundColor: "var(--body-color-less)",
                  border: `1px solid ${alpha(btncolor || "#1976d2", 0.15)}`,
                  display: "flex",
                  gap: 2,
                  alignItems: "flex-start",
                }}
              >
                <InfoIcon sx={{ color: btncolor, mt: 0.3, flexShrink: 0 }} />
                <Box>
                  <Typography
                    sx={{
                      fontSize: "0.92rem",
                      fontWeight: 700,
                      color: "var(--text-color)",
                      mb: 0.5,
                    }}
                  >
                    Not sure which to choose?
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "0.85rem",
                      color: "var(--text-color)",
                      opacity: 0.7,
                      lineHeight: 1.6,
                    }}
                  >
                    Individual accounts are for personal use, while Enterprise
                    accounts are for registered businesses.
                    <br />
                    <strong>Note:</strong> If you are a merchant seeking card
                    payment services, you must complete{" "}
                    <strong>Enterprise KYC verification</strong>.
                  </Typography>
                </Box>
              </Box>

              <InfoPopUp
                open={show}
                onClose={handleClose}
                title={"CLICK HERE TO BEGIN"}
                description={`Before clicking on this button make sure that you have a
                      valid ID document and address proof document.`}
              />
            </Box>
          )}

          {userType === 1 && (
            <Box
              sx={{
                margin: "20px",
                position: "relative",
              }}
            >
              {steps > 1 && (
                <Box
                  sx={{
                    position: "absolute",
                    top: 20,
                    right: 20,
                    zIndex: 10,
                  }}
                >
                  <OutlinedButton
                    onClick={() => {
                      setSteps(1);
                      setUserType(null);
                    }}
                    startIcon={
                      <RestartAltIcon sx={{ fontSize: "1rem !important" }} />
                    }
                    sx={{
                      textTransform: "none",
                      fontWeight: 700,
                      borderRadius: "8px",
                      fontSize: "0.72rem",
                      py: 0.4,
                      px: 1.5,
                      height: "30px",
                      minWidth: "auto",
                      backgroundColor: "var(--body-color-less)",
                      borderColor: "rgba(125,125,125,0.2)",
                      "&:hover": {
                        backgroundColor: "var(--body-color-less2)",
                        borderColor: alpha(btncolor || "#1976d2", 0.4),
                      },
                    }}
                  >
                    Change Type
                  </OutlinedButton>
                </Box>
              )}
              {steps === 2 && (
                <IdentityVerificationAddress
                  handleSteps={handleSteps}
                  handleBack={handleBack}
                  userDetails={userDetails}
                  setIsloading={setIsloading}
                />
              )}
              {steps === 3 && (
                <IdentityVerificationDOB
                  handleSteps={handleSteps}
                  handleBack={handleBack}
                  userDetails={userDetails}
                  setIsloading={setIsloading}
                />
              )}
              {steps === 4 && (
                <IdentityVerificationEmployee
                  handleSteps={handleSteps}
                  handleBack={handleBack}
                  userDetails={userDetails}
                  setIsloading={setIsloading}
                />
              )}
              {steps > 4 && (
                <IdentityVerificationDocument
                  handleSteps={handleSteps}
                  handleBack={handleBack}
                  userDetails={userDetails}
                  steps={steps}
                  setIsloading={setIsloading}
                />
              )}
            </Box>
          )}
          {userType === 2 && (
            <Box
              sx={{
                margin: "20px",
                position: "relative",
              }}
            >
              {steps > 1 && (
                <Box
                  sx={{
                    position: "absolute",
                    top: 20,
                    right: 20,
                    zIndex: 10,
                  }}
                >
                  <OutlinedButton
                    onClick={() => {
                      setSteps(1);
                      setUserType(null);
                    }}
                    startIcon={
                      <RestartAltIcon sx={{ fontSize: "1rem !important" }} />
                    }
                    sx={{
                      textTransform: "none",
                      fontWeight: 700,
                      borderRadius: "8px",
                      fontSize: "0.72rem",
                      py: 0.4,
                      px: 1.5,
                      height: "30px",
                      minWidth: "auto",
                      backgroundColor: "var(--body-color-less)",
                      borderColor: "rgba(125,125,125,0.2)",
                      "&:hover": {
                        backgroundColor: "var(--body-color-less2)",
                        borderColor: alpha(btncolor || "#1976d2", 0.4),
                      },
                    }}
                  >
                    Change Type
                  </OutlinedButton>
                </Box>
              )}
              {steps === 2 && (
                <CompanyInformation
                  handleSteps={handleSteps}
                  handleBack={handleBack}
                  userDetails={userDetails}
                  setIsloading={setIsloading}
                />
              )}
              {steps > 2 && (
                <CompanyDocumentUpload
                  handleSteps={handleSteps}
                  handleBack={handleBack}
                  userDetails={userDetails}
                  setIsloading={setIsloading}
                  steps={steps}
                  getUserDetails={getUserDetails}
                />
              )}
            </Box>
          )}
        </>
      )}

      {isLoading && <Loading />}
    </Box>
  );
};

export default Dashboard;
